import { apiClient } from "../axiosClient";

export interface ContactRequest {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export const submitContact = async (data: ContactRequest) => {
  const response = await apiClient.post("/contact", data);
  return response.data;
};